module.exports = __webpack_public_path__ + "static/media/our_events.1f92ca22.png";